/**
 * ボタン非活性
 */
window.disableButtons = function () {
    // ボタン非活性
    $('#store').prop('disabled', true);
    $('#show_pdf').prop('disabled', true);
    $('#clear').prop('disabled', true);
    $('#copy').prop('disabled', true);
    $('#complete').prop('disabled', true);
    $('#delete').prop('disabled', true);
    $('#return').prop('disabled', true);
    $('#reject').prop('disabled', true);
    $('#update').prop('disabled', true);
    // 承認関連
    $('#send_approval_start').prop('disabled', true);
    $('#confirm_approval').prop('disabled', true);
    $('#send_approval_ok').prop('disabled', true);
    $('#send_approval_cancel').prop('disabled', true);
    // 送信関連
    $('#send_back').prop('disabled', true);
    $('#send_order').prop('disabled', true);
    $('#send_estimate').prop('disabled', true);
    $('#send_cancel').prop('disabled', true);
    // 契約関連
    $('#confirm_contract_agreed').prop('disabled', true);
    $('#accept_estimate').prop('disabled', true);
    $('#confirm_contracted').prop('disabled', true);
    $('#create_purchase_order').prop('disabled', true);
    $('#create_purchase_received_order').prop('disabled', true);
    $('#create_sales_order').prop('disabled', true);
    $('#send_contract').prop('disabled', true);
    $('#cancel_contract').prop('disabled', true);
}

/**
 * ローディング切替(登録・更新）
 */
window.changeStoreLoading = function () {
    // ローディング切替
    $('#store i').hide();
    $('#store div').show();
}

/**
 * ローディング切替(更新）※受発注のステータス遷移無し更新で利用
 */
window.changeUpdateLoading = function() {
    // ローディング切替
    $('#update i').hide();
    $('#update div').show();
}

/**
 * ローディング切替(削除）
 */
window.changeDeleteLoading = function () {
    // ローディング切替
    $('#delete i').hide();
    $('#delete div').show();
}

/**
 * ローディング切替(済）
 */
window.changeCompleteLoading = function () {
    // ローディング切替
    $('#complete i').hide();
    $('#complete div').show();
}

/**
 * ローディング切替(複製）
 */
window.changeCopyLoading = function () {
    // ローディング切替
    $('#copy i').hide();
    $('#copy div').show();
}

/**
 * ローディング切替(不採択）
 */
window.changeRejectLoading = function () {
    // ローディング切替
    $('#reject i').hide();
    $('#reject div').show();
}

/**
 * ローディング切替(承認：申請）
 */
window.changeApprovalStartLoading = function () {
    // ローディング切替
    $('#send_approval_start i').hide();
    $('#send_approval_start div').show();
}

/**
 * ローディング切替(承認：承認/否認）
 */
window.changeApprovalConfirmLoading = function () {
    // ローディング切替
    $('#confirm_approval i').hide();
    $('#confirm_approval div').show();
}

/**
 * ローディング切替(承認：承認）
 */
window.changeApprovalOkLoading = function () {
    // ローディング切替
    $('#send_approval_ok i').hide();
    $('#send_approval_ok div').show();
}

/**
 * ローディング切替(承認：差戻し）
 */
window.changeApprovalCancelLoading = function () {
    // ローディング切替
    $('#send_approval_cancel i').hide();
    $('#send_approval_cancel div').show();
}

/**
 * ローディング切替(送信：見積）
 */
window.changeSendEstimateLoading = function () {
    // ローディング切替
    $('#send_estimate i').hide();
    $('#send_estimate div').show();
}

/**
 * ローディング切替(送信：受注）
 */
window.changeSendReceiveLoading = function () {
    // ローディング切替
    $('#send_receive i').hide();
    $('#send_receive div').show();
}

/**
 * ローディング切替(送信：発注）
 */
window.changeSendOrderLoading = function () {
    // ローディング切替
    $('#send_order i').hide();
    $('#send_order div').show();
}

/**
 * ローディング切替(送信：納品）
 */
window.changeSendDeliveryOrderLoading = function () {
    // ローディング切替
    $('#send_delivery i').hide();
    $('#send_delivery div').show();
}

/**
 * ローディング切替(送信：キャンセル）
 */
window.changeCancelAPILoading = function () {
    // ローディング切替
    $('#send_cancel i').hide();
    $('#send_cancel div').show();
}

/**
 * ローディング切替(送信：差し戻し）
 */
window.changeSendBackLoading = function () {
    // ローディング切替
    $('#send_back i').hide();
    $('#send_back div').show();
}

/**
 * ローディング切替(連携無し:契約承諾）
 */
window.changeConfirmContractAgreedLoading = function () {
    // ローディング切替
    $('#confirm_contract_agreed i').hide();
    $('#confirm_contract_agreed div').show();
}

/**
 * ローディング切替(契約キャンセル）
 */
window.changeCancelContractLoading = function () {
    // ローディング切替
    $('#cancel_contract i').hide();
    $('#cancel_contract div').show();
}

/**
 * ローディング切替(契約承諾）
 */
window.changeAcceptContractLoading = function () {
    // ローディング切替
    $('#accept_estimate i').hide();
    $('#accept_estimate div').show();
}

/**
 * ローディング切替(契約送信）
 */
window.changeSendContractLoading = function () {
    // ローディング切替
    $('#send_contract i').hide();
    $('#send_contract div').show();
}

/**
 * ローディング切替(契約済）
 */
window.changeConfirmContractedLoading = function () {
    // ローディング切替
    $('#confirm_contracted i').hide();
    $('#confirm_contracted div').show();
}
